'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var ThemedHistory_module = require('./ThemedHistory.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ThemedHistory = ({
  event
}) => {
  const time = event.dateFormatted[1];
  let location = [event.city, event.state].filter(Boolean).join(', ');
  if (location !== '') {
    location = ` | ${location}`;
  }
  const {
    bodytextDefaultNone,
    smalltextDefaultNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("li", {
    className: ThemedHistory_module["default"].listItem
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      ...smalltextDefaultNone
    }
  }, /*#__PURE__*/React__default["default"].createElement("time", null, time), /*#__PURE__*/React__default["default"].createElement("span", null, location)), /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      ...bodytextDefaultNone,
      margin: 0
    }
  }, event.description));
};
var History = nthHookTheme.withThemeProvider(ThemedHistory, {
  themeTokens: ['bodytextDefaultNone', 'smalltextDefaultNone']
});

exports["default"] = History;
